module.exports = __webpack_public_path__ + "static/media/wu.2fe6343e.ogg";